import type { ReactNode } from 'react';

export function ErrorNote({ children }: { children: ReactNode }) {
  if (!children) return null;
  return (
    <p className="rounded-xl bg-miss/10 px-3 py-2 text-[13px] font-semibold text-danger">
      {children}
    </p>
  );
}
